// extracted by mini-css-extract-plugin
export default {"container":"Search_container__FpDfx","button":"Search_button__W5MQY","input":"Search_input__klILD","input-icon":"Search_input-icon__QCCvD"};